const CustomFieldInitialValuesMap = {
  COMMON: {
    field_name: "",
    description: "",
  },
  ADDRESS: {
    addressLineOne: "",
    addressLineTwo: "",
    city: "",
    state: "",
    country: "",
    zip: "",
  },
  PERSON_NAME: {
    firstName: "",
    lastName: "",
  },
  CHECKBOX: {
    options: [""],
    default: [false],
  },
  RADIO: {
    options: ["", ""],
    default: [false, false],
  },
  SINGLE_SELECT: {
    options: ["", ""],
    default: [false, false],
  },
  EMAIL: {
    default: "",
  },
  NUMBER: {
    default: "",
  },
  PERCENT: {
    default: "",
  },
  PHONE: {
    default: "",
  },
  SINGLE_LINE_TEXT: {
    default: "",
  },
  URL: {
    default: "",
  },
  MULTI_LINE_TEXT: {
    default: "",
  },
  DATE: {
    format: "",
  },
  COUNTRY: {
    options: [],
    default: "",
  },
  RATE: {
    options: [],
    rateValue: "",
    rateUom: "",
  },
  PERIOD: {
    options: [],
    periodValue: "",
    periodUom: "",
  },
  AMOUNT: {
    currency: "",
    default: "",
  },
  US_STATES: {
    options: [],
    default: "",
  },
};

const CustomFieldComponentRules = {
  COMMON: {
    field_name: {
      required: ({ value }) => value.trim("").length > 0,
    },
    description: {
      required: ({ value }) => value.trim("").length > 0,
      // minLength: ({ value }) => value.trim("").length > 5,
    },
  },
  ADDRESS: {
    addressLineOne: {
      required: ({ value }) => value.trim("").length > 0,
    },
    // addressLineTwo: {
    //   required: ({ value }) => value.trim("").length > 0,
    // },
    city: {
      required: ({ value }) => value.trim("").length > 0,
    },
    state: {
      required: ({ value }) => value.trim("").length > 0,
    },
    // country: {
    //   required: ({ value }) => value.trim("").length > 0,
    // },
    zip: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  PERSON_NAME: {
    firstName: {
      required: ({ value }) => value.trim("").length > 0,
    },
    lastName: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  SINGLE_SELECT: {
    options: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  CHECKBOX: {
    options: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  RADIO: {
    options: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  EMAIL: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
      validateEmail: ({ value }) => {
        // eslint-disable-next-line no-useless-escape
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // return re.test(String(value).toLowerCase());
        const emailstatus = re.test(String(value).toLowerCase());
        return emailstatus;
      },
    },
  },
  NUMBER: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  DATE: {
    format: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  PERCENT: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
      minMax: ({ value }) => value > 0 && value <= 100,
    },
  },
  AMOUNT: {
    currency: {
      required: ({ value }) => value.trim("").length > 0,
    },
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  COUNTRY: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  US_STATES: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  PHONE: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
      validatePhone: ({ value }) => {
        // eslint-disable-next-line no-useless-escape
        const re = /^[0-9\b]+$/;
        const number = re.test(value);
        return number;
      },
    },
  },
  RATE: {
    rateValue: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  PERIOD: {
    periodValue: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  SINGLE_LINE_TEXT: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  MULTI_LINE_TEXT: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
    },
  },
  URL: {
    default: {
      required: ({ value }) => value.trim("").length > 0,
      validateUrl: ({ value }) => {
        // eslint-disable-next-line no-useless-escape
        const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
        const urlstatus = re.test(value);
        return urlstatus;
      },
    },
  },
};

const CustomFieldComponentMessages = {
  COMMON: {
    field_name: {
      required: "Field name is a mandatory field",
    },
    description: {
      required: "Field description is a mandatory field",
      minLength: "Field description should have a minimum length of 5",
    },
  },
  ADDRESS: {
    addressLineOne: {
      required: "Please enter address line one field",
    },
    city: {
      required: "Please enter city",
    },
    state: {
      required: "Please enter the state",
    },
    zip: {
      required: "Please enter the zip code",
    },
  },
  PERSON_NAME: {
    firstName: {
      required: "Please enter first name",
    },
    lastName: {
      required: "Please enter last name",
    },
  },
  AMOUNT: {
    currency: {
      required: "Please enter number",
    },
    default: {
      required: "Please enter value",
    },
  },
  SINGLE_SELECT: {
    options: [""],
    default: [false],
  },
  RADIO: {
    options: [""],
    default: [false],
  },
  CHECKBOX: {
    options: {
      required: "Please enter a default value",
    },
  },
  EMAIL: {
    default: {
      required: "Please enter email",
      validateEmail: "Please enter valid email",
    },
  },
  NUMBER: {
    default: {
      required: "Please enter number",
    },
  },
  PERCENT: {
    default: {
      required: "Please enter number",
      minMax: "Enter a value between 0 and 100",
    },
  },
  PHONE: {
    default: {
      required: "Please enter Phone number",
      validatePhone: "Please enter valid Phone number",
    },
  },
  SINGLE_LINE_TEXT: {
    default: {
      required: "Please enter value",
    },
  },
  MULTI_LINE_TEXT: {
    default: {
      required: "Please enter value",
    },
  },
  RATE: {
    rateValue: {
      required: "Please enter value",
    },
  },
  PERIOD: {
    periodValue: {
      required: "Please enter value",
    },
  },
  DATE: {
    format: {
      required: "Please select format",
    },
  },
  URL: {
    default: {
      required: "Please enter URL",
      validateUrl: "Please enter valid URL",
    },
  },
};

export {
  CustomFieldInitialValuesMap,
  CustomFieldComponentMessages,
  CustomFieldComponentRules,
};



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/CustomFieldRulesMap.js